import React from "react";
import Movies from "../components/movies";



function Home() {
    return (
      <div className="App ">
         <Movies />
         
            
      </div>
    );
  }
  
  export default Home;